export type ConnectionStatus =
  | 'Closed'
  | 'Establishing'
  | 'Established'
  | 'Expiring'
  | 'Expired'
  | 'Dropped'
  | 'Closing'
  | 'EstablishedOidc';
type SessionStatus = 'Closed' | 'Closing' | 'Established';

export type UserType = 'Anonymous' | 'Agency' | 'Corporate';

export interface ConnectionState {
  status: ConnectionStatus;
  ssoStatus?: SessionStatus;
}

export interface PartnerInformationResponse {
  name: string;
  emailAddress: string;
  externalNote: string;
}

export interface SessionState {
  accessToken?: string;
  tokenType?: string;
  duration?: number;
  expiresAt?: number;
  userType?: UserType;
  connection: ConnectionState;
  partnerInformation?: PartnerInformationResponse;
}

export const EmptySession: SessionState = {
  accessToken: undefined,
  tokenType: undefined,
  duration: undefined,
  expiresAt: undefined,
  userType: undefined,
  connection: {
    status: 'Closed',
    ssoStatus: 'Closed'
  }
};
